import { css, styled, mq } from 'mymoria-ui';
import { Heading } from 'mymoria-ui/components';
import React, { FunctionComponent } from 'react';
import { PhoneIcon } from 'components';
import { global } from 'data';

interface Props {
  isTop?: boolean;
  isWhite?: boolean;
}
const StyledCirclePhone = styled.div<Props>(
  ({ isTop, isWhite, theme: { colors, font } }) => css`
    margin-left: 0.75rem;
    height: ${!isTop && '100%'};
    padding: ${isTop ? '0.35rem' : '0 0.35rem'};
    width: 100%;

    span,
    h2 {
      text-align: left;
      display: block;
      white-space: nowrap;
      color: ${isWhite ? colors.black : colors.white};
      font-family: ${font.family.proximaNova};
      line-height: ${isWhite && '1.15rem'};
    }

    span {
      font-size: ${isWhite ? font.size.tiny : font.size.normal};
    }

    ${mq({
      display: ['none', 'none', 'none', 'flex'],
    })};
  `,
);

const StyledPhone = styled.a`
  display: flex;
  align-items: center;
  width: 100%;
  ${mq({
    marginRight: [0, '0.5rem'],
  })};
`;

const StyledIcon = styled(PhoneIcon)<Props>(
  ({ isWhite }) => css`
    height: ${isWhite && '2.5rem'};
    width: ${isWhite && '2.5rem'};

    svg {
      height: ${isWhite && '2.25rem'};
      width: ${isWhite && '2.25rem'};
    }
  `,
);

const CirclePhone: FunctionComponent<Props> = ({ isTop = true, isWhite = false }) => (
  <StyledCirclePhone isTop={isTop} isWhite={isWhite}>
    <StyledPhone href={global.header.phoneHref}>
      <StyledIcon isWhite={isWhite} />
      <div>
        <span>{global.header.phoneText}</span>
        <Heading.Heading2>{global.header.phoneNumber}</Heading.Heading2>
      </div>
    </StyledPhone>
  </StyledCirclePhone>
);

export default CirclePhone;
